module.exports = __webpack_public_path__ + "static/img/IMG_20151229_150305.99ecec5c.jpg";